import { Button, Card, DatePicker, Modal } from "antd";
import { Link, useNavigate } from "react-router-dom";
import {
  useGetLedgerPostMutation,
  useGetLiveCasinoListQuery,
} from "../../../store/service/CasinoServices";
import moment from "moment";
import CustomLoading from "../../common/CustomLoading/CustomLoading";
import { useState } from "react";
import "./MatchLedgerCasino.scss";

const { RangePicker } = DatePicker;

const MatchLedgerCasino = () => {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const { data, isFetching, isLoading } = useGetLiveCasinoListQuery();
  const [trigger, { isLoading: loading }] = useGetLedgerPostMutation();
  const rows = data?.data || [];

  const handleLedgerPost = async () => {
    try {
      await trigger({}).unwrap();
    } catch {
      /* ignore */
    }
  };

  return (
    <div className="match_slip match_ledger mlc-page">
      <Card
        className="sport_detail team_name mlc-card"
        title="Match Ledger"
        extra={
          <button type="button" className="mlc-back" onClick={() => nav(-1)}>
            Back
          </button>
        }
        style={{ margin: 0, width: "100%" }}>
        <div className="mlc-toolbar">
          <RangePicker className="mlc-range" bordered showSecond={false} />
          <div className="mlc-actions">
            <Button type="primary" className="mlc-btn">
              Submit
            </Button>
            <Button type="primary" className="mlc-btn" onClick={() => setOpen(true)}>
              Post Ledger
            </Button>
          </div>
        </div>

        <div className="table_section statement_tabs_data ant-spin-nested-loading mlc-table-wrap">
          {(isFetching || isLoading) && <CustomLoading />}

          {/* Desktop / tablet table */}
          <table className="live_table login_data_table mlc-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Date & Time</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((items, index) => (
                <tr key={items?.tableId || index}>
                  <td>{index + 1}</td>
                  <td>
                    <Link to={`/casino/${items?.tableId}`} className="mlc-link">
                      {items?.name}
                    </Link>
                  </td>
                  <td>{moment().format("YYYY-MM-DD hh:mm A")}</td>
                  <td>
                    <div className="mlc-row-actions">
                      <Link className="mlc-mini-btn" to={`/casino/${items?.tableId}`}>
                        View
                      </Link>
                      <Link
                        className="mlc-mini-btn ghost"
                        to={`/display-games/${items?.tableId}/${items?.name}`}>
                        Display
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Mobile cards */}
          <div className="mlc-mobile-list">
            {rows.map((items, index) => (
              <article key={items?.tableId || index} className="mlc-mobile-card">
                <div className="mlc-mobile-top">
                  <span className="mlc-code">#{index + 1}</span>
                  <time>{moment().format("DD MMM, hh:mm A")}</time>
                </div>
                <h3>
                  <Link to={`/casino/${items?.tableId}`}>{items?.name}</Link>
                </h3>
                <div className="mlc-mobile-actions">
                  <Link className="mlc-mini-btn" to={`/casino/${items?.tableId}`}>
                    View
                  </Link>
                  <Link
                    className="mlc-mini-btn ghost"
                    to={`/display-games/${items?.tableId}/${items?.name}`}>
                    Display
                  </Link>
                </div>
              </article>
            ))}
            {!rows.length && !isLoading ? (
              <div className="mlc-empty">No casino tables found</div>
            ) : null}
          </div>
        </div>
      </Card>

      <Modal
        title="Confirm"
        open={open}
        onOk={() => {
          handleLedgerPost();
          setOpen(false);
        }}
        confirmLoading={loading}
        onCancel={() => setOpen(false)}
        className="ledger_post_modal"
        okText="Post"
        cancelText="Cancel">
        <p className="mlc-modal-text">Post the casino ledger now?</p>
      </Modal>
    </div>
  );
};

export default MatchLedgerCasino;
